"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var PropTypes = require("prop-types");
var React = require("react");
var saveCanvasHelpers_1 = require("./helpers/saveCanvasHelpers");
var importImageHelpers_1 = require("./helpers/importImageHelpers");
var eventHelpers_1 = require("./helpers/eventHelpers");
var canvasHelpers_1 = require("./helpers/canvasHelpers");
var objectUrlHelpers_1 = require("./helpers/objectUrlHelpers");
var miscHelpers_1 = require("./helpers/miscHelpers");
var ReactPainter = /** @class */ (function (_super) {
    __extends(ReactPainter, _super);
    function ReactPainter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.canvasRef = null;
        _this.ctx = null;
        _this.lastX = 0;
        _this.lastY = 0;
        _this.scalingFactor = 1;
        _this.state = {
            canvasHeight: 0,
            canvasWidth: 0,
            color: _this.props.initialColor,
            imageCanDownload: null,
            imageDownloadUrl: null,
            isDrawing: false,
            lineCap: _this.props.initialLineCap,
            lineJoin: _this.props.initialLineJoin,
            lineWidth: _this.props.initialLineWidth
        };
        _this.handleMouseDown = function (e) {
            var _a = eventHelpers_1.extractOffSetFromEvent(e, _this.scalingFactor, _this.canvasRef), offsetX = _a.offsetX, offsetY = _a.offsetY;
            _this.lastX = offsetX;
            _this.lastY = offsetY;
            _this.setState({
                isDrawing: true
            });
        };
        _this.handleMouseMove = function (e) {
            var _a = _this.state, color = _a.color, lineWidth = _a.lineWidth, lineCap = _a.lineCap, lineJoin = _a.lineJoin;
            if (_this.state.isDrawing) {
                var _b = eventHelpers_1.extractOffSetFromEvent(e, _this.scalingFactor, _this.canvasRef), offsetX = _b.offsetX, offsetY = _b.offsetY;
                var ctx = _this.ctx;
                ctx.strokeStyle = color;
                ctx.lineWidth = lineWidth * _this.scalingFactor;
                ctx.lineCap = lineCap;
                ctx.lineJoin = lineJoin;
                var lastX = _this.lastX;
                var lastY = _this.lastY;
                ctx.beginPath();
                ctx.moveTo(lastX, lastY);
                ctx.lineTo(offsetX, offsetY);
                ctx.stroke();
                _this.lastX = offsetX;
                _this.lastY = offsetY;
            }
        };
        _this.handleMouseUp = function () {
            _this.setState({
                isDrawing: false
            });
        };
        _this.handleSave = function () {
            var onSave = _this.props.onSave;
            saveCanvasHelpers_1.canvasToBlob(_this.canvasRef, 'image/png')
                .then(function (blob) {
                onSave(blob);
                _this.setState({
                    imageDownloadUrl: objectUrlHelpers_1.fileToUrl(blob)
                });
            })
                .catch(function (err) { return console.error('in ReactPainter handleSave', err); });
        };
        _this.handleSetColor = function (color) {
            _this.setState({
                color: color
            });
        };
        _this.handleSetLineWidth = function (lineWidth) {
            _this.setState({
                lineWidth: lineWidth
            });
        };
        _this.handleSetLineJoin = function (type) {
            _this.setState({
                lineJoin: type
            });
        };
        _this.handleSetLineCap = function (type) {
            _this.setState({
                lineCap: type
            });
        };
        _this.initCanvasContext = function () {
            var _a = _this.state, color = _a.color, lineWidth = _a.lineWidth, lineJoin = _a.lineJoin, lineCap = _a.lineCap;
            _this.ctx = _this.canvasRef.getContext('2d');
            _this.ctx.strokeStyle = color;
            _this.ctx.lineWidth = lineWidth * _this.scalingFactor;
            _this.ctx.lineJoin = lineJoin;
            _this.ctx.lineCap = lineCap;
        };
        _this.initCanvasNoImage = function (width, height) {
            _this.canvasRef.width = width;
            _this.canvasRef.height = height;
            _this.setState({
                canvasHeight: height,
                canvasWidth: width
            });
            _this.initCanvasContext();
        };
        _this.initCanvasWithImage = function (width, imgWidth, imgHeight) {
            var _a = canvasHelpers_1.getCanvasDimensionsScaledForImage(width, imgWidth, imgHeight), cvWidth = _a[0], cvHeight = _a[1], scalingRatio = _a[2];
            _this.canvasRef.width = imgWidth;
            _this.canvasRef.height = imgHeight;
            _this.setState({
                canvasHeight: cvHeight,
                canvasWidth: cvWidth
            });
            _this.scalingFactor = 1 / scalingRatio;
            _this.initCanvasContext();
        };
        _this.getCanvasProps = function (props) {
            if (props === void 0) { props = {}; }
            var onMouseDown = props.onMouseDown, onTouchStart = props.onTouchStart, onMouseMove = props.onMouseMove, onTouchMove = props.onTouchMove, onMouseUp = props.onMouseUp, onTouchEnd = props.onTouchEnd, style = props.style, ref = props.ref, restProps = __rest(props, ["onMouseDown", "onTouchStart", "onMouseMove", "onTouchMove", "onMouseUp", "onTouchEnd", "style", "ref"]);
            return __assign({ onMouseDown: miscHelpers_1.composeFn(onMouseDown, _this.handleMouseDown), onMouseMove: miscHelpers_1.composeFn(onMouseMove, _this.handleMouseMove), onMouseUp: miscHelpers_1.composeFn(onMouseUp, _this.handleMouseUp), onTouchEnd: miscHelpers_1.composeFn(onTouchEnd, _this.handleMouseUp), onTouchMove: miscHelpers_1.composeFn(onTouchMove, _this.handleMouseMove), onTouchStart: miscHelpers_1.composeFn(onTouchStart, _this.handleMouseDown), ref: miscHelpers_1.composeFn(ref, function (canvasRef) {
                    _this.canvasRef = canvasRef;
                }), style: __assign({ height: _this.state.canvasHeight, width: _this.state.canvasWidth }, style) }, restProps);
        };
        return _this;
    }
    ReactPainter.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, width = _a.width, height = _a.height, image = _a.image;
        // Disable touch action as we handle it separately
        document.body.style.touchAction = 'none';
        if (image) {
            importImageHelpers_1.importImage(image)
                .then(function (_a) {
                var img = _a.img, imgWidth = _a.imgWidth, imgHeight = _a.imgHeight;
                _this.initCanvasWithImage(width, imgWidth, imgHeight);
                _this.ctx.drawImage(img, 0, 0, imgWidth, imgHeight);
                _this.setState({
                    imageCanDownload: true
                });
            })
                .catch(function () {
                _this.setState({
                    imageCanDownload: false
                });
                _this.initCanvasNoImage(width, height);
            });
        }
        else {
            this.initCanvasNoImage(width, height);
        }
    };
    ReactPainter.prototype.componentWillUnmount = function () {
        // Enable touch action again
        document.body.style.touchAction = null;
        objectUrlHelpers_1.revokeUrl(this.state.imageDownloadUrl);
    };
    ReactPainter.prototype.render = function () {
        var render = this.props.render;
        var _a = this.state, imageCanDownload = _a.imageCanDownload, imageDownloadUrl = _a.imageDownloadUrl;
        var canvasNode = React.createElement("canvas", __assign({}, this.getCanvasProps()));
        return typeof render === 'function'
            ? render({
                canvas: canvasNode,
                getCanvasProps: this.getCanvasProps,
                imageCanDownload: imageCanDownload,
                imageDownloadUrl: imageDownloadUrl,
                setColor: this.handleSetColor,
                setLineCap: this.handleSetLineCap,
                setLineJoin: this.handleSetLineJoin,
                setLineWidth: this.handleSetLineWidth,
                triggerSave: this.handleSave
            })
            : canvasNode;
    };
    ReactPainter.propTypes = {
        color: PropTypes.string,
        height: PropTypes.number,
        image: PropTypes.oneOfType([PropTypes.instanceOf(File), PropTypes.string]),
        lineCap: PropTypes.string,
        lineJoin: PropTypes.string,
        lineWidth: PropTypes.number,
        onSave: PropTypes.func,
        render: PropTypes.func,
        width: PropTypes.number
    };
    ReactPainter.defaultProps = {
        height: 300,
        image: undefined,
        onSave: function () { return undefined; },
        initialColor: '#000',
        initialLineCap: 'round',
        initialLineJoin: 'round',
        initialLineWidth: 5,
        width: 300
    };
    return ReactPainter;
}(React.Component));
exports.ReactPainter = ReactPainter;
//# sourceMappingURL=ReactPainter.js.map